// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"51a3586f","346":"30d0c416","754":"12e04aab","777":"cc6c8c4f","992":"7f3c200a"}[chunkId] + ".chunk.css";
};